import { message } from "antd"
import React from "react"
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { notificationSucces } from "../../services/notification"
import { sendSystemLog, useAuth } from "../../context/AuthProvider/useAuth"
import { serverUrl } from "../../services/api"



function index() {
  const {response} = useAuth()
  const log = {
    log_type: 'visited',
    log_object: 'welcomes'
  }

  useEffect(() => {
    sendSystemLog(log);
  }, [])
  
  return (
    <div className="welcome">
        <meta name="viewport" content="width=device-width, initial-scale=.75"/>
        <h1 className="welcome__title">Welcome {response?.welcome}</h1> 
        <div className="welcome__images">
          {response && response.images?.length > 0 && response.images.map((image) => (
            <a href={image.link || '#'} target="_blank">
              <img src={serverUrl+image.image} style={{width: '100%', marginBottom: 20}}/>
            </a>
          ))}
        </div>
        {response && response?.affiliation==="organization" && ( <h4>NOTICE TO GAMBLING MANAGERS:  Game selection is at the sole discretion of the charities.
            Charities are not required to accept all games.
            Please notify your Distributor if you do not want available games automatically loaded to your sites.</h4>
        )}
    </div>
  )
}

export default index
